import * as Yup from "yup";

export const trialPatientSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .test("has-dot-after-at", "Invalid email address", (value) => {
      if (!value) {
        return true;
      }

      const atIndex = value.indexOf("@");
      if (atIndex === -1 || atIndex === value.length - 1) {
        return false; // No @ or @ is the last character
      }

      return value.substring(atIndex + 1).includes(".");
    }),

  confirm_email: Yup.string()
    .oneOf([Yup.ref("email"), null], "Emails must match")
    .required("Confirm email is required"),

  first_name: Yup.string().trim().required("First name is required"),

  middle_name_initial: Yup.string().max(1, "Only one letter allowed"),

  last_name: Yup.string().trim().required("Last name is required"),

  birth_date: Yup.date()
    .required("Birth date is required")
    .min(new Date("1900-01-01"), "Must be after 1900.")
    .max(new Date(), "Must be in the past."),

  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\+[1-9]\d{10,14}$/, "Phone number is not valid"),

  trial_id: Yup.string().required("Trial is required"),

  participant_number: Yup.string()
    .nullable()
    .matches(/^\d*$/, "Subject number must contain only digits"), // Optional, depends on is_manual etc.

  start_date: Yup.string().required("Start date is required"),
});
